import $ from 'jquery';

const termsCheckbox = document.querySelector( '#terms-conditions' );
const button = document.querySelector( '#resetpass-button' );
const detailsInCorrect = document.querySelector( '#form-incorrect-details' );
const detailsCorrect = document.querySelector( '#form-correct-details' );
const message = document.querySelector( '.form-content-wrapper--toggle' );

function handleDetailsClick() {
  return detailsInCorrect.checked ? $( message ).slideDown() : $( message ).slideUp();
}

function handleTermsClick( e ) {
  button.disabled = !e.currentTarget.checked;
}

function init() {
  if ( !termsCheckbox || !button ) {
    return;
  }

  termsCheckbox.addEventListener( 'change', handleTermsClick );
  detailsCorrect.addEventListener( 'change', handleDetailsClick );
  detailsInCorrect.addEventListener( 'change', handleDetailsClick );
}

export default {
  init,
};
